export const newsDataSource = {
  product: [
    {
      title: '爱瑟福解锁智能座舱通信最优解---AVB vs A2B 战略选型指南',
      type: 'weChart',
      href: 'https://mp.weixin.qq.com/s/0LQd2sXlA58FSzL_2OdlTg',
      date: '2025-07-15',
      cover: require('@/static/logo_1.png')
    },
    {
      title: '开辟智能汽车通信新天地：爱瑟福XL4Link Pro车载通信技术解决方案',
      type: 'weChart',
      href: 'https://m.gasgoo.com/apps/ShareArticleContent/2/70413875.html',
      date: '2024-1-19',
      cover: require('@/assets/article/new_sky.png')
    },
    {
      title: '红旗E001项目SOME/IP协议栈技术攻关',
      href: '20002',
      date: '2024-1-19',
      cover: require('@/static/logo_1.png')
    },
  ],
  company: [
    {
      title: '爱瑟福科技信息有限公司北京车展参展报道',
      type: 'weChart',
      href: 'https://mp.weixin.qq.com/s/pErHS9vufvT-8-bioV1QCA',
      date: '2024-05-22',
      cover: require('@/assets/article/article-03.jpg')
    },
    {
      title: '爱瑟福诚邀您参观2024北京国际汽车展',
      type: 'weChart',
      href: 'https://mp.weixin.qq.com/s/EbfNaAk8T_QPA09q37aiBQ',
      date: '2024-04-23',
      cover: require('@/assets/article/article-02.png')
    },
    {
      title: '跨越.感谢 爱瑟福-年度优秀员工表彰暨2024-年会',
      type: 'weChart',
      href: 'https://mp.weixin.qq.com/s/D8fg8zq-B4wjcj2b1JuuTA',
      date: '2024-02-02',
      cover: require('@/assets/article/article-01.png')
    },
    {
      title: '5.2H馆-C111 Excelfore在工博会等你',
      href: '10001',
      date: '2023-11-8',
      cover: require('@/static/logo_1.png')
    },
    {
      title: '新征程，再起航',
      type: 'weChart',
      href: 'https://mp.weixin.qq.com/s/t6iszz5ZEGoR6oLebEIXAg',
      date: '2023-07-21',
      cover: require('@/static/logo_1.png')
    },
    {
      title: '初心不改，一路前行, Excelfore中国正式成立',
      href: '20001',
      date: '2017-06-28',
      cover: require('@/static/logo_1.png')
    },
  ],
  profession: [
    {
      title: '从挑战到机遇：AVB与TSN为智能网联汽车开辟新天地',
      href: 'https://mp.weixin.qq.com/s/xFpFMZaUtqgcLdJuLQJIPA',
      type: 'weChart',
      date: '2024-11-04',
      cover: require('@/assets/article/avb.png')
    },
    {
      title: '汽车智能诊断的风口是否已经到来？',
      href: 'https://mp.weixin.qq.com/s/NRogiR0XneP51CfRnxAn8g',
      type: 'weChart',
      date: '2024-09-20',
      cover: require('@/assets/article/smart_diagnosis.png')
    },
    {
      title: '聚焦“车云一体化”，爱瑟福加速破局向新',
      href: 'https://mp.weixin.qq.com/s/xqUByY9a_dflUUKba3--Fw',
      type: 'weChart',
      date: '2024-07-17',
      cover: require('@/assets/article/vehicle_cloud.png')
    },
    {
      title: '新能源汽车行业洗牌在即，2023-谁主沉浮？',
      href: 'https://www.36kr.com/p/2071699615743109',
      type: 'weChart',
      date: '2023-01-03',
      cover: 'https://img.36krcdn.com/20230103/v2_cfb1f773a88542f2bd4a5c9ec6630c97_img_000?x-oss-process=image/format,jpg/interlace,1'
    },
  ]
};
